// @ts-nocheck
// TODO: tighten types after migration
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AdminHome.css";
import WorldClock from "../components/WorldClock";
import ContentPlanner from "./ContentPlanner";
import { useNavPinned } from "./useNavPinned";

function AdminHomeIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3L4 9v12h5v-7h6v7h5V9z"/>
        </svg>
    );
}

function AdminDatabaseIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"/>
        </svg>
    );
}

function QuotesIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
        </svg>
    );
}

export default function AdminHome() {
    const [showClock, setShowClock] = useState(true);
    const [navPinned, setNavPinned] = useNavPinned();

    return (
        <div className="admin-container w-full max-w-none px-0 pb-[20px]">
            <nav className={`admin-topnav sticky top-[10px] z-[50] mb-[14px] flex items-center gap-[10px] rounded-[12px] bg-bg/95 p-[8px] shadow-[0_4px_16px_rgba(0,0,0,0.08)] backdrop-blur ${navPinned ? ' admin-topnav-pinned' : ''}`}>
                <Link to="/admin" className="admin-topnav-item admin-topnav-active flex h-[40px] w-[40px] items-center justify-center rounded-[8px]" title="Home">
                    <AdminHomeIcon />
                </Link>
                <Link to="/admin/database" className="admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px]" title="Database">
                    <AdminDatabaseIcon />
                </Link>
                <Link to="/admin/user-dashboard" className="admin-topnav-item flex h-[40px] w-[40px] items-center justify-center rounded-[8px]" title="Dashboard">
                    <i className="fi fi-ss-chart-pie" style={{ fontSize: 20, lineHeight: 1, display: "flex", alignItems: "center" }}></i>
                </Link>
                <button
                    className={`admin-topnav-pin-btn ml-auto flex h-[36px] items-center justify-center rounded-[8px] border border-slider px-[10px] ${navPinned ? ' admin-topnav-pin-active' : ''}`}
                    onClick={() => setNavPinned(v => !v)}
                    title={navPinned ? "Unpin nav" : "Pin nav"}
                >
                    <i className="fi fi-sr-thumbtack"></i>
                </button>
            </nav>
            <main className="admin-content">
                <div className="admin-dashboard-wrapper rounded-[14px] bg-bg p-[14px] shadow-[0_2px_12px_rgba(0,0,0,0.06)]">
                    <div className="admin-clock-section">
                        {showClock && <WorldClock />}
                    </div>
                    <div className="admin-welcome-section mt-[8px]">
                        <div className="admin-welcome-header-group">
                            <h1 className="admin-welcome-heading text-[2rem] font-[800]">Welcome to Admin page</h1>
                        </div>
                    </div>
                    <div className="clock-toggle-wrapper">
                        <button
                            className="clock-toggle-btn"
                            onClick={() => setShowClock(!showClock)}
                            title={showClock ? "Hide Clock" : "Show Clock"}
                        >
                            <i className={`fi fi-sr-caret-down ${showClock ? "rotate-180" : ""}`}></i>
                        </button>
                    </div>
                </div>

                <ContentPlanner />

                <div className="admin-temporary-service-wrapper mt-[16px]">
                    <div className="admin-services-section rounded-[14px] bg-bg p-[14px] shadow-[0_2px_12px_rgba(0,0,0,0.06)]">
                        <h2 className="admin-service-heading mb-[12px] text-[1.2rem] font-[700]">Temporary service</h2>
                        <div className="admin-service-grid grid grid-cols-1 gap-[10px] sm:grid-cols-2 lg:grid-cols-3">
                            <Link to="/admin/quotes" className="admin-service-card flex items-center gap-[12px] rounded-[10px] border border-slider p-[12px] transition-colors hover:bg-hover">
                                <div className="admin-service-icon text-[1.3rem]">
                                    <QuotesIcon size={32} />
                                </div>
                                <span className="admin-service-text font-[600]">Daily Quotes</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
